import React, { useState, useRef, useContext } from 'react';
import { MenuTab, MenuTabs } from './MenuTabs'
import styles from './MenuTabs.module.css'
import Stage1 from './Stage1';
import Stage2 from './Stage2';
import Stage3 from './Stage3';
import Stage4 from './Stage4';
import Stage5 from './Stage5';
import Stage6 from './Stage6';
import Stage7 from './Stage7';

import MenuContext from './MenuContext';
import { useFormContext } from "./FormContext";
import { validateStage, validateStage1, validateStage2, validateStage3 } from './validation';


function Workflowtabs() {

  const { activeTab, setActiveTab } = useContext(MenuContext);
  const { formData, updateFormData, errors, setErrors } = useFormContext();

  const changeMenu = (menu) => {
    //console.log(menu);
    const activeTabNumber = activeTab.match(/\d+/)?.[0];
    
    if (activeTabNumber === '1') {
      const { isValid, errors } = validateStage1(formData.stage1);
      const { file1, file2, file3, file4 } = errors;

      // Array of files to loop through and update respective indexes
      const files = [file1, file2, file3, file4];

      // Create a new file_upload_status object that we will update during the loop
      let updatedFileUploadStatus = { ...formData.stage1?.file_upload_status };

      // Loop through the files array and set isLoading: true for non-null files
      files.forEach((file, idx) => {
        
        if (typeof(file) === 'string' && file !== null) {  // Check if the file is not null
          updatedFileUploadStatus[idx] = {
            ...(updatedFileUploadStatus[idx] || {}),
            error: true,
            success: false,
            isLoading: false,
          };
        }
      });

      // Now, update the entire formData at once with the accumulated changes
      updateFormData("stage1", {
        ...formData.stage1,
        file_upload_status: updatedFileUploadStatus,
        isValid,
        errors
      });
    }else if(activeTabNumber === '2'){
      const { isValid, errors } = validateStage2(formData.stage2);
     
      updateFormData("stage2", {
        ...formData.stage2,
        isValid,
        errors 
      });
    }
    //console.log(formData)
    // if (isValid) {
      if (true) {
      setActiveTab(menu);
    } else {
      //console.log(errors);
      setActiveTab(menu);
    }
  }

  return (
    <div className='container-fluid createworkflowsection2'>
      <div className='container mycontainer'>
        <MenuTabs name="Workflowtab" changeHandler={changeMenu} tabState={{ activeTab: activeTab }} style={styles} >
          <MenuTab label='Stage1' name='Initialize Workflow' key='1'>
            <Stage1 />
          </MenuTab>
          <MenuTab label='Stage2' name='Temporal Settings' key='2'>
            <Stage2 />
          </MenuTab>
          <MenuTab label='Stage3' name='Data Selection' key='3'>
            <Stage3 />
          </MenuTab>
          <MenuTab label='Stage4' name='Data Availability' key='4'>
            <Stage4 />
          </MenuTab>
          <MenuTab label='Stage5' name='Promotions' key='5'>
            <Stage5 />
          </MenuTab>
          <MenuTab label='Stage6' name='Model Selection' key='6'>
            <Stage6 />
          </MenuTab>
          <MenuTab label='Stage7' name='Review & Launch Workflow' key='7'>
            <Stage7 />
          </MenuTab>
        </MenuTabs>
      </div>
    </div>
  )
}

export default Workflowtabs
